/**
 * Horizontal Images Block JavaScript
 * Scroll effect: left image translates up, right image translates down as user scrolls
 */

(function() {
    'use strict';

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const Y_AMOUNT = 150; // pixels of movement
    const MD_BREAKPOINT = 768;

    function initScrollEffect(block) {
        if (window.innerWidth < MD_BREAKPOINT) return;

        var leftItem = block.querySelector('.horizontal-images__item--2');
        var rightItem = block.querySelector('.horizontal-images__item--3');
        if (!leftItem || !rightItem) return;

        var gallery = block.querySelector('.horizontal-images__gallery');
        var triggerEl = gallery || block;

        var stConfig = {
            trigger: triggerEl,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            invalidateOnRefresh: true
        };

        // Left image: translate up (negative Y)
        gsap.fromTo(leftItem, { y: 0 }, {
            y: -Y_AMOUNT,
            ease: 'none',
            scrollTrigger: Object.assign({}, stConfig)
        });

        // Right image: translate down (positive Y)
        gsap.fromTo(rightItem, { y: 0 }, {
            y: Y_AMOUNT,
            ease: 'none',
            scrollTrigger: Object.assign({}, stConfig)
        });

        requestAnimationFrame(function() {
            ScrollTrigger.refresh();
        });
    }

    function killScrollEffect(block) {
        ScrollTrigger.getAll().forEach(function(st) {
            var trigger = st.trigger;
            if (trigger && block && (trigger === block || block.contains(trigger))) {
                st.kill();
            }
        });
        var items = block.querySelectorAll('.horizontal-images__item');
        items.forEach(function(el) {
            gsap.set(el, { clearProps: 'transform' });
        });
    }

    function initBlocks() {
        var blocks = document.querySelectorAll('.horizontal-images');
        blocks.forEach(function(block) {
            initScrollEffect(block);
        });
    }

    function handleResize() {
        var blocks = document.querySelectorAll('.horizontal-images');
        blocks.forEach(function(block) {
            killScrollEffect(block);
            if (window.innerWidth >= MD_BREAKPOINT) {
                initScrollEffect(block);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(initBlocks, 100);
        });
    } else {
        setTimeout(initBlocks, 100);
    }

    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResize, 150);
    });
})();
